import React from 'react';
import TechActivityContainer from '../../containers/techActivity/TechActivityContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const TechActivityPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="기술활동관리/기술일정등록" icon="partner" />
      <TechActivityContainer />
    </>
  );
};

export default TechActivityPage;
